import PropTypes from 'prop-types';
import { useState } from 'react';
import { Button, Form, Modal, Spinner } from 'react-bootstrap';
import { useDispatch } from 'react-redux';
import { deleteRealEstate } from 'redux/realEstateSlice';
import messageHandler from 'utils/messageHandler';

const ModalDeleteRE = ({ show, handleClose, estateName, realEstateId }) => {
  // * States
  const [value, setValue] = useState('');
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);

  // * Methods
  const DeleteRealEstate = async () => {
    setLoading(true);
    const response = await dispatch(deleteRealEstate(realEstateId));

    if (response.status === 200) {
      messageHandler('success', response.data.message);
      handleClose();
    } else
      messageHandler(
        'error',
        'Ocurrió un error y no se pudo eliminar la inmobiliaria. Por favor, inténtelo de nuevo más tarde.'
      );

    setLoading(false);
  };

  return (
    <Modal show={show} onHide={handleClose} centered>
      <Modal.Header closeButton>
        <Modal.Title>Eliminar inmobiliaria</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p>{`¿Está seguro que desea eliminar por completo la inmobiliaria "${estateName}"?`}</p>
        <p>Una vez eliminada se llevarán a cabo las siguientes acciones:</p>
        <li>Eliminaremos todas las propiedades de "{estateName}".</li>
        <li>
          La inmobiliaria estará inactiva y los usuarios no podrán ingresar a la
          gestión de la misma.
        </li>
        <li>"{estateName}" no aparecerá en los listados de inmobiliarias.</li>
        <br />
        <p> Para continuar, escriba el nombre completo de la inmobiliaria.</p>
        <Form.Control
          type="text"
          size="md"
          value={value}
          onChange={e => setValue(e.target.value)}
          placeholder={estateName}
        />
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={handleClose}>
          Cancelar
        </Button>
        <div className="d-flex justify-content-end">
          <Button
            variant="danger"
            onClick={
              !loading && estateName === value ? DeleteRealEstate : () => {}
            }
            disabled={loading || estateName !== value}
            className="d-flex justify-content-center align-items-center"
          >
            {loading ? (
              <Spinner
                as="span"
                animation="border"
                size="sm"
                role="status"
                aria-hidden="true"
              />
            ) : (
              'Eliminar'
            )}
          </Button>
        </div>
      </Modal.Footer>
    </Modal>
  );
};

ModalDeleteRE.propTypes = {
  show: PropTypes.bool,
  handleClose: PropTypes.func,
  estateName: PropTypes.string,
  realEstateId: PropTypes.string
};

export default ModalDeleteRE;
